/** Tag convention for Wave todo items mirrored to Vida/Drift `Todo.categories`. */
export function waveTodoCategories(spaceId, waveId, widgetIndex) {
    return [`wave:${spaceId}`, `wave-id:${waveId}`, `widget:${widgetIndex}`];
}
/** Deterministic cloud todo id for per-user mirror rows. */
export function waveTodoMirrorId(waveId, blockId, itemId) {
    return `wave-${waveId}-${blockId}-${itemId}`;
}
/** Yjs comment anchor for a single todo item inside a TODO_LIST block. */
export function todoItemCommentAnchor(blockId, itemId) {
    return `${blockId}#${itemId}`;
}
export function parseTodoItemCommentAnchor(anchor) {
    const idx = anchor.indexOf("#");
    if (idx <= 0)
        return null;
    return { blockId: anchor.slice(0, idx), itemId: anchor.slice(idx + 1) };
}
/** Deep link to Drift filtered by wave tag (best-effort). */
export function driftDeepLinkForWave(waveId) {
    return `drift://tasks?category=${encodeURIComponent(`wave-id:${waveId}`)}`;
}
